import { httpGet, httpPost, httpPatchMerge, httpDelete } from './http'
import type { ITsdResource } from '~/types/tsd/models'
import type { TEntityId } from '~/types/models'
import { Address } from '~/cynqueModules/dataObjects/Address'

const apiEntityPath = '/api/tsdresources'

export async function getTsdResources({ apiPath = apiEntityPath } = {}) {
  const callingMn = getTsdResources.name
  return httpGet<ITsdResource[]>({ callingMn, apiPath })
}

// export async function getTsdResourcesPreProcessed({
//   apiPath = apiEntityPath,
// } = {}) {
//   const callingMn = getTsdResources.name
//   const rawTsdResources = await httpGet<ITsdResource[]>({
//     callingMn,
//     apiPath,
//   })
//   return rawTsdResources.map((rawTsdResource) => {
//     return rawTsdResource.address === undefined
//       ? rawTsdResource
//       : Object.assign(
//           rawTsdResource,
//           (rawTsdResource.address = Address(rawTsdResource.address))
//         )
//   })
// }

export async function createTsdResource(entity: ITsdResource) {
  const callingMn = createTsdResource.name
  const apiPath = apiEntityPath
  return httpPost<ITsdResource>({ callingMn, apiPath, entity })
}

export async function updateTsdResource(
  entityData: Partial<ITsdResource>,
  id: TEntityId
) {
  const callingMn = updateTsdResource.name
  const apiPath = `${apiEntityPath}/${id}`
  type TPartialITsdResource = Partial<ITsdResource>
  return httpPatchMerge<TPartialITsdResource>({
    callingMn,
    apiPath,
    entityData,
  })
}

export async function deleteTsdResource(entityData: ITsdResource) {
  const callingMn = deleteTsdResource.name
  const apiPath = apiEntityPath
  return httpDelete<ITsdResource>({
    callingMn,
    apiPath,
    entityData,
  })
}
